import getUserConfiguration from '../actions/getUserConfiguration';

export default function getDensityModeString(): string {
    const selectedDensityMode = getUserConfiguration().UserOptions.DisplayDensityMode;

    if (selectedDensityMode === 'Full') {
        return 'full';
    } else if (selectedDensityMode === 'Simple') {
        return 'medium';
    } else if (selectedDensityMode === 'Compact') {
        return 'compact';
    } else {
        throw new Error('Not a valid density mode');
    }
}
